export default "/images/c10d611d7c83fc5cceb804db31ca38d9.avif";